import script from "./StudyDataPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StudyDataPage.vue?vue&type=script&setup=true&lang=js"

import "./StudyDataPage.vue?vue&type=style&index=0&id=9bb583ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bb583ca"]])

export default __exports__